import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'resumenbanco',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      f_c: {
        estado: false,
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },

  mounted() {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],
    });
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $('.box').boxWidget();
  },

  computed: {
    reporte: function () {
      return (
        "/reportes/resumen/banco?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      let fl = 0;
      if (this.filtro_li) {
        fl = 1;
        let column5 = this.tbv.column(5)
        column5.visible(false);

        let column4 = this.tbv.column(4)
        column4.visible(false);

      } else {
        fl = 0;
        let column5 = this.tbv.column(5)
        column5.visible(true);

        let column4 = this.tbv.column(4)
        column4.visible(true);
      }

      this.$http
        .post('/reportes/resumen/banco', this.f_c)
        .then(response => {

          if (response.data.status === 1) {
            const { data } = response.data;
            data.forEach(row => {
              row[6] = this.num_to_many(row[6]);
              this.tbv.row.add(row);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  },

  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/resumenbanco/index.js